define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"csi/xml",
	"csi/xml/Query"
], function(declare,Widget,xml,Query) {

	return declare(Widget, {
		_resolveView: function() {
			// summary: show just active WBS elements
			this.relRoot.addQuery(new Query()
				.Attr("WState", xml.OP_EQUALS, "Wbs.State:InProcess", "Child:WBS")
				.Attr("WEActive", xml.OP_EQUALS, "true")
			);

			this.inherited(arguments);
		}
	});
});
